import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Field, Fields, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button } from '@getgrover/ui';

import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import ggAuth from 'ggApp/modules/auth';
import { LayoutComponent_Text as LayoutComponentText } from 'ggApp/modules/layout';
import ggForm, {
    FormComponent_Select as FormComponentSelect,
    FormComponent_Input as FormComponentInput,
    FormComponent_InputDoubled as FormComponentInputDoubled,
} from 'ggApp/modules/form';
import { Translator } from 'ggApp/modules/translator/components';

import { Form, Wrap } from './styles';

const FormName = 'checkoutEditAddress';

const { requiredValidation, cityValidation } = ggForm.validations;

class CheckoutEditAddressForm extends Component {
    render() {
        const {
            modal,
            edit,
            countryList,
            handleSubmit,
            submitting,
            error,
            disableCountry,
            userDevice,
        } = this.props;

        const isMobile = userDevice === 'mobile';

        const zipcodeParser = (code) => {
            const isNl = countryList.some((i) => i.id === 166);

            if (!isNl) {
                return code;
            }

            return code.replace(/([0-9]+)([A-Za-z])/, '$1 $2');
        };

        return (
            <Form onSubmit={handleSubmit(edit)} modal={modal}>
                <Wrap>
                    <Field
                        id={`${FormName}CountryIdSelect`}
                        disabled={disableCountry}
                        reqMark
                        globalError={error}
                        name="country_id"
                        type="select"
                        label="FORM_LABEL_COUNTRY"
                        data={countryList}
                        component={FormComponentSelect}
                    />
                    <Fields
                        reqMark
                        globalError={error}
                        ids={[`${FormName}Address1Input`, `${FormName}Address2Input`]}
                        names={['address1', 'address2']}
                        labels={['FORM_LABEL_STREET', 'FORM_LABEL_HOUSE']}
                        flexes={!isMobile ? [0.75, 0.25] : [0.65, 0.35]}
                        component={FormComponentInputDoubled}
                    />
                    <Field
                        id={`${FormName}AdditionalInfo`}
                        name="additional_info"
                        type="text"
                        label="FORM_LABEL_ADDITIONAL"
                        component={FormComponentInput}
                    />
                    <Fields
                        reqMark
                        globalError={error}
                        ids={[`${FormName}ZipcodeInput`, `${FormName}CityInput`]}
                        names={['zipcode', 'city']}
                        labels={['FORM_LABEL_POSTCODE', 'FORM_LABEL_CITY']}
                        flexes={!isMobile ? [0.25, 0.75] : [0.35, 0.65]}
                        component={FormComponentInputDoubled}
                        parse={zipcodeParser}
                    />

                    {!!error && (
                        <LayoutComponentText mini error>
                            {error}
                        </LayoutComponentText>
                    )}
                </Wrap>

                <LayoutComponentText mini lightWeight>
                    <Translator tk="FORM_MANDATORY_FIELDS" />
                </LayoutComponentText>

                <Button type="submit" primary fullWidth centred loading={submitting}>
                    <Translator tk="CONFIRM" />
                </Button>
            </Form>
        );
    }
}

CheckoutEditAddressForm.propTypes = {
    edit: PropTypes.func.isRequired,
    countryList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.shape({}),
    disableCountry: PropTypes.bool,
    userDevice: PropTypes.string.isRequired,
};

CheckoutEditAddressForm.defaultProps = {
    submitting: false,
    error: null,
    disableCountry: false,
};

const enhance = compose(
    withDeviceInfo,
    connect(
        createStructuredSelector({
            authFetching: ggAuth.selectors.fetching,
        }),
    ),
    reduxForm({
        getFormState: (state) => ggForm.selectors.reduxForm(state),
        form: FormName,
        enableReinitialize: true,
        validate: (values) => {
            const errors = {};

            errors.country_id = requiredValidation(values.country_id);
            errors.address1 = requiredValidation(values.address1);
            errors.address2 = requiredValidation(values.address2);
            errors.zipcode = requiredValidation(values.zipcode);
            errors.city = cityValidation(values.city);

            return errors;
        },
    }),
);

export default enhance(CheckoutEditAddressForm);
